module.exports = __webpack_public_path__ + "img/icon_alipay@2x.ad6cf143.png";